import { useEffect } from 'react';
import {
  activateWorkItemShortcut,
  isEditorTarget,
  WORK_ITEM_SHORTCUTS,
} from '../../lib/work-types';
import CreateProjectModal from './CreateProjectModal';
import CreateViewModal from './CreateViewModal';
import CreateWorkItemModal from './CreateWorkItemModal';
import PowerK from './PowerK';
import ShortcutsDialog from './ShortcutsDialog';
import { useOverlays } from './overlay-context';

export default function OverlayRoot() {
  const { openPowerK, openShortcuts, powerKOpen, isBlocked } = useOverlays();

  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      const meta = event.metaKey || event.ctrlKey;
      if (meta && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        openPowerK();
        return;
      }
      if (meta && event.key === '/') {
        event.preventDefault();
        openShortcuts();
        return;
      }
      if (isEditorTarget(event.target)) return;
      if (isBlocked) return;
      if (event.altKey || event.shiftKey || event.repeat) return;
      const control = WORK_ITEM_SHORTCUTS[event.key.toLowerCase()];
      if (!control) return;
      if (activateWorkItemShortcut(control)) {
        event.preventDefault();
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [openPowerK, openShortcuts, powerKOpen, isBlocked]);

  return (
    <>
      <CreateWorkItemModal />
      <CreateProjectModal />
      <CreateViewModal />
      <PowerK />
      <ShortcutsDialog />
    </>
  );
}
